@if (routerLink(); as link) {
  <a
    routerLinkActive="bg-primary/10"
    [routerLink]="link"
    class="flex w-full items-center gap-3 rounded-xl p-3 text-left transition-colors hover:bg-base-300"
    (click)="onAction()"
  >
    <div class="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-base-200">
      <lucide-icon [name]="icon()" class="h-6 w-6 stroke-current text-base-content/70" />
    </div>
    <div class="min-w-0 flex-1">
      <div class="flex items-center justify-between gap-2">
        <span class="font-semibold text-sm">{{ title() }}</span>
        @if (badge() !== undefined) {
          <span class="badge badge-sm badge-primary">{{ badge() }}</span>
        }
      </div>
      <span class="block text-sm text-base-content/70">{{ subtitle() }}</span>
    </div>
  </a>
} @else {
  <button
    type="button"
    class="flex w-full items-center gap-3 rounded-xl p-3 text-left transition-colors hover:bg-base-300 cursor-pointer"
    (click)="onAction()"
  >
    <div class="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-base-200">
      <lucide-icon [name]="icon()" class="h-6 w-6 stroke-current text-base-content/70" />
    </div>
    <div class="min-w-0 flex-1">
      <span class="font-semibold text-sm">{{ title() }}</span>
      <span class="block text-sm text-base-content/70">{{ subtitle() }}</span>
    </div>
  </button>
}
